// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dbecfe9f","551":"27c2c232"}[chunkId] + ".chunk.js";
};